/**
 * Multi-Symbol Comparison Showcase - Crypto market comparison
 * Demonstrates: Symbol linking, workspace save/load, 8-chart grid
 */
export const comparisonShowcase = {
    name: "comparison",
    label: "So sánh đa mã",
    description: "So sánh 8 mã crypto cùng lúc với symbol linking",
    layout: { rows: 2, cols: 4 },
    charts: [
        { id: "crypto-btc", symbol: "BTCUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-eth", symbol: "ETHUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-sol", symbol: "SOLUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-bnb", symbol: "BNBUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-xrp", symbol: "XRPUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-doge", symbol: "DOGEUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-ada", symbol: "ADAUSDT", timeframe: "1h", symbolLinkGroup: "D" },
        { id: "crypto-avax", symbol: "AVAXUSDT", timeframe: "1h", symbolLinkGroup: "D" },
    ],
    defaultChartProps: {
        showToolbar: true,
        showHeader: true,
        showFooter: true,
        drawingUiEnabled: true,
        theme: "classic-dark",
    },
    syncSettings: {
        syncVisibleRange: true,
        syncCrosshair: true,
        syncDrawings: false, // Don't sync drawings across different symbols
        syncSymbolLinks: true,
        syncTimeframe: true,
        syncChartType: true,
    },
    featuredPanels: ["workspace", "drawings"],
    activeBottomTab: null,
    // Workspace features
    workspaceId: "crypto-comparison",
    enableWorkspacePersistence: true,
};
